import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { Router } from '@angular/router';

const REDIRECT_DELAY = 3;

@Component({
  selector: 'app-reset-password-success',
  templateUrl: './reset-password-success.component.html',
  styleUrls: ['./reset-password-success.component.scss'],
})
export class ResetPasswordSuccessComponent implements OnInit, OnDestroy {
  countdown = signal(REDIRECT_DELAY);
  private countdownTimer: ReturnType<typeof setInterval> | null = null;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.countdownTimer = setInterval(() => {
      const next = this.countdown() - 1;
      this.countdown.set(next);
      if (next <= 0) {
        this.goToLogin();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  goToLogin(): void {
    this.clearTimer();
    this.router.navigate(['/login']);
  }

  private clearTimer(): void {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }
}
